import { calc } from '@/utils'
import { SxProps } from '@mui/material'
import { headerDimensions } from '../Header.data'

interface HeaderEventInfoStyles {
  eventInfoWrapper: SxProps
  eventName: SxProps
  eventDescWrapper: SxProps
  eventDesc: SxProps
  venueDesc: SxProps
  dot: SxProps
}

export const headerEventInfoStyles: HeaderEventInfoStyles = {
  eventInfoWrapper: {
    textAlign: 'center',
    maxWidth: {
      xs: calc(headerDimensions.gapInPx * 2 + 36 + headerDimensions.logo.iconMobile), // logo width + action button width + padding
    },
  },
  eventName: {
    typography: 'textXsSemibold',
    color: 'pageTheme.textColor',
  },
  eventDescWrapper: {
    display: 'flex',
    gap: 1,
    justifyContent: 'center',
    color: 'pageTheme.textColor',
  },
  eventDesc: {
    typography: 'textXs',
  },
  venueDesc: {
    display: { xs: 'none', md: 'block' },
  },
  dot: {
    display: { xs: 'none', md: 'block' },
    backgroundColor: 'pageTheme.textColor',
  },
}
